import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "@phosphor-icons/react";

const KEY = "pc360_cookie_ack";

// Lightweight ePrivacy cookie notice. PerCen360 only sets an essential httpOnly
// session cookie (no advertising/tracking cookies), so this is an informational
// acknowledgement stored locally — shown once.
export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try { setShow(!localStorage.getItem(KEY)); } catch (e) { console.debug("cookie ack read failed", e); }
  }, []);

  const accept = () => {
    try { localStorage.setItem(KEY, "1"); } catch (e) { console.debug("cookie ack write failed", e); }
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[90] px-4 pb-4 pointer-events-none no-print"
      data-testid="cookie-banner"
    >
      <div className="glass rounded-2xl max-w-3xl mx-auto p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4 pointer-events-auto">
        <div className="flex items-start gap-3 flex-1">
          <Cookie size={22} weight="duotone" color="#FFB020" className="mt-0.5 shrink-0" />
          <p className="text-sm text-white/75 leading-relaxed">
            We use a single essential cookie to keep you signed in — no tracking or
            advertising cookies. See our{" "}
            <Link to="/privacy" className="text-[#FFB020] underline">Privacy Policy</Link>.
          </p>
        </div>
        <button
          type="button"
          onClick={accept}
          className="btn-gold shrink-0 justify-center"
          data-testid="cookie-accept-button"
        >
          Got it
        </button>
      </div>
    </div>
  );
}
